import { z } from 'zod';
import { OFFER_CAMPAIGN_MAX_ITEMS } from '@dukanti/shared';

const BIDI_OVERRIDE_RE = /[\u202A-\u202E\u2066-\u2069]/;

function isValidDateTimeLocal(value: string): boolean {
  const date = new Date(value);
  return value.trim().length > 0 && Number.isFinite(date.getTime());
}

export function createOfferCampaignFormSchema() {
  return z
    .object({
      title: z
        .string()
        .trim()
        .min(1, { message: 'admin.offerCampaigns.errors.titleRequired' })
        .max(100, { message: 'admin.offerCampaigns.errors.titleTooLong' })
        .refine((value) => !BIDI_OVERRIDE_RE.test(value), {
          message: 'admin.offerCampaigns.errors.titleInvalid',
        }),
      short_description: z
        .string()
        .trim()
        .max(240, { message: 'admin.offerCampaigns.errors.descriptionTooLong' })
        .refine((value) => !BIDI_OVERRIDE_RE.test(value), {
          message: 'admin.offerCampaigns.errors.titleInvalid',
        }),
      starts_at: z.string().refine(isValidDateTimeLocal, {
        message: 'admin.offerCampaigns.errors.invalidWindow',
      }),
      ends_at: z.string().refine(isValidDateTimeLocal, {
        message: 'admin.offerCampaigns.errors.invalidWindow',
      }),
      is_active: z.boolean(),
      variant_ids: z
        .array(z.string().trim().min(1))
        .min(1, { message: 'admin.offerCampaigns.errors.emptySelection' })
        .max(OFFER_CAMPAIGN_MAX_ITEMS, {
          message: 'admin.offerCampaigns.errors.itemLimitExceeded',
        })
        .refine((ids) => new Set(ids).size === ids.length, {
          message: 'admin.offerCampaigns.errors.duplicateSelection',
        }),
    })
    .refine((values) => new Date(values.ends_at).getTime() > new Date(values.starts_at).getTime(), {
      message: 'admin.offerCampaigns.errors.invalidWindow',
      path: ['ends_at'],
    });
}

export type OfferCampaignFormValues = z.infer<ReturnType<typeof createOfferCampaignFormSchema>>;
